/* eslint react/no-direct-mutation-state: "off",'no-redeclare': 'off', eqeqeq: 'off', no-useless-escape: 'off', no-useless-concat: 'off' */
import React, { Component } from "react";
import { Table,Label,Button,Modal } from "reactstrap";
import { connect } from "react-redux";
import '../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../Assets/EnsembleStyles/WorkOrders.css'
import { GetWorkorderList, GetEquipmentWorkorderList, GetWorkorderTechnician,GetClosedWorkorderList, DeleteWorkOrder } from "../../../action/workorderAction";
import { getAllResources } from '../../../action/cultureAction';
import { getUserDetailsAfterLogin } from '../../../action/cultureAction';
import WorkOrderDetails from './WorkOrderDetails';
import DeleteConfirmation from '../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import SelectAllCheckboxes from '../../../Resources/SelectAllCheckboxes';
import * as ErrorMessage from '../../../Resources/ErrorMessages';
import { createFilter } from 'react-search-input';
import ReactPaginate from 'react-paginate';
import { FaPrint } from 'react-icons/fa';
import TraneLogo from '../../../Assets/icons/Icons__trane-logo.svg';
import TraneTechLogo from '../../../Assets/icons/tt_logo_tm_color_rgb.png';
import LoadingIndicator from '../Common/LoadingIndicator';
import { Icon } from 'semantic-ui-react';
import ErrorGif from '../../../Assets/images/Error.gif';

const KEYS_TO_FILTERS = ['serialNumber', 'tenantName', 'buildingName', 'problem', 'description', 'urgency', 'technicianName', 'dueDate', 'statusName', 'createdByDate'];
let pagesCount = 0, PrintPaginationText = '';
class Workorderlist extends Component {
    componentWillMount() {
        
        this.props.getUserDetailsAfterLogin();
        //this.props.GetWorkOrderBuildings();
        this.props.GetWorkorderTechnician();

        var FilterDetails = sessionStorage.getItem('WorkOrderFilterDetails');
        if (FilterDetails !== undefined && FilterDetails !== null && FilterDetails !== "null") {
            var lFilterDetails = JSON.parse(FilterDetails);
            if(lFilterDetails.filtervalue === "6"){
                this.props.GetClosedWorkorderList();
            }
            this.setState({ FilterValue: lFilterDetails.filtervalue, IsClosedStatus: lFilterDetails.isclosedstatus, currentPage: 0 });
        }

        const l_Request = this.props.ForEquipment ? this.props.GetEquipmentWorkorderList(this.props.EquipmentSummaryId) : this.props.GetWorkorderList(); 
        l_Request.then((result) => {
            this.setState({isloading:false});
            var MailDetails = localStorage.getItem('mailWorkOrderId');
            if (MailDetails !== undefined && MailDetails !== null && MailDetails !== "null" && MailDetails !== "") {
                let data = this.props.getList.WorkOrderList;
                if (data !== undefined && data !== null && data.length > 0) {
                    let data1 = data.filter(x => x.workOrderID == MailDetails);
                    if (data1 !== undefined && data1 !== null && data1.length > 0) {
                        this.setState({ redirect: true, WorkOrderId: MailDetails, IsMail: true });
                        localStorage.setItem("mailWorkOrderId", null);
                    }
                }
            }
        });
        
        if (this.props.getLabels === undefined || this.props.getLabels["WorkOrders.Columns.Record.Text"] === undefined) {
            this.props.getAllResources();
        }

        var el = document.getElementsByClassName('Ensemble_Content_FullPage'); 
        if(el[0] !== undefined)
            el[0].scrollIntoView();   
    }
    
    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            currentPage: 0,
            pageSize: 50,
            sort: {
                column: null,
                direction: [
                    { name: 'workOrderID', direction: 'desc', onclick: false },
                    { name: 'tenantName', direction: 'desc', onclick: false },
                    { name: 'siteName', direction: 'desc', onclick: false },
                    { name: 'problemID', direction: 'desc', onclick: false },
                    { name: 'description', direction: 'desc', onclick: false },
                    { name: 'urgency', direction: 'desc', onclick: false },
                    { name: 'assignedUserID', direction: 'desc', onclick: false },
                    { name: 'dueDate', direction:'desc', onclick: false},
                    { name: 'status', direction: 'desc', onclick: false },
                    { name: 'createdByDate', direction: 'desc', onclick: true }
                ]
            },
            searchTerm: "",
            redirect: false,
            WorkOrderId: 0,
            statusId: 0,
            FilterValue: "1",
            IsDefaultSort: true,
            IsClosedStatus: false,
            IsMail: false,
            error_msg: false,
            deletemodal: false,
            CreatedByUserID: 0
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.OnFilterChange = this.OnFilterChange.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.UpdateRedirection = this.UpdateRedirection.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);
    }

    componentWillReceiveProps(){
        if(this.props.WorkOrderId !== '' && this.props.isRedirect !== false && this.props.isRedirect !== undefined){
                this.setState({WorkOrderId: this.props.WorkOrderId, redirect: this.props.isRedirect});
            }
    }

    /* Filter System */
    OnFilterChange() {
        var selectedOption = this.refs.filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.filter_in_Select_input.options[selectedOption].id;
        var lClosedStatus = lFilterId == '6' ? true : false;
        if(lClosedStatus){
            this.props.GetClosedWorkorderList().then(() => {this.setState({ FilterValue: lFilterId, IsClosedStatus: lClosedStatus, currentPage: 0 });}); //Calling Closed Workorder API
        }
        else{
            this.setState({ FilterValue: lFilterId, IsClosedStatus: lClosedStatus, currentPage: 0 });
        }
        var Data = ({ 'filtervalue': lFilterId, 'isclosedstatus': lClosedStatus });
        sessionStorage.setItem('WorkOrderFilterDetails', JSON.stringify(Data));
        document.getElementsByClassName("WO_header_Check_box")[0].checked = false;
        var checkboxes = document.getElementsByClassName('WorkOrderRows');
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false;
        }
    }

    /* Search System */
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.wo_search_value.value, currentPage: 0 })
        document.getElementsByClassName("WO_header_Check_box")[0].checked = false;
    }

    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
        document.getElementsByClassName("WO_header_Check_box")[0].checked = false;
    };

    /* Sorting  System */
    onSortNumber = (column) => (e) => {
        this.setState({ IsDefaultSort: false, IsClosedStatus: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = (this.state.FilterValue !== "6") ? this.props.getList.WorkOrderList : this.props.getList.ClosedWorkOrderList;
        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA, nameB;
                nameA = a[column];
                nameB = b[column];
                return (nameA - nameB);
            });
            if (direction === 'desc') {
                sortedData.reverse();
            }

            if (selected[0].name == "workOrderID") {
                SortData[0].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "workOrderID") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if(this.state.FilterValue !== "6")
                this.props.getList.WorkOrderList = sortedData;
            else
                this.props.getList.ClosedWorkOrderList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('WorkOrderSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.FilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('WorkOrderFilterDetails', JSON.stringify(Data1));
        }
    };

    onSort = (column) => (e) => {
        this.setState({ IsDefaultSort: false, IsClosedStatus: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = (this.state.FilterValue !== "6") ? this.props.getList.WorkOrderList : this.props.getList.ClosedWorkOrderList;
        var notequals = 0;

        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA, nameB;
                if (column === "siteName" || column === "problemID" || column === "tenantName") {
                    if (column === "problemID") {
                        nameA = a.workOrderDetail.problemID === 8 ? a.workOrderDetail.otherProblem : (a.workOrderDetail.problemID !== 0 ? this.props.getLabels['WorkOrders.Problem.' + a.workOrderDetail.problemID + '.Text'] : "");
                        nameB = b.workOrderDetail.problemID === 8 ? b.workOrderDetail.otherProblem : (b.workOrderDetail.problemID !== 0 ? this.props.getLabels['WorkOrders.Problem.' + b.workOrderDetail.problemID + '.Text'] : "");
                    }
                    else if (column === "tenantName") {
                        nameA = a.workOrderDetail[column].toLowerCase();
                        nameB = b.workOrderDetail[column].toLowerCase();
                    }
                    else if (column === "siteName") {
                        let Buildings = this.props.getList.WorkorderBuildings;
                        var buildingdts1 = [], buildingdts2 = [];
                        if (Buildings !== null && Buildings !== undefined && Buildings.length > 0) {
                            buildingdts1 = Buildings.filter(function (item) {
                                return item.id === a.workOrderDetail.siteID
                            });
                            buildingdts2 = Buildings.filter(function (item) {
                                return item.id === b.workOrderDetail.siteID
                            });
                        }
                        nameA = (buildingdts1 !== [] && buildingdts1[0] !== undefined) ? buildingdts1[0].name : "";
                        nameB = (buildingdts2 !== [] && buildingdts2[0] !== undefined) ? buildingdts2[0].name : "";
                        if (nameA < nameB) {
                            notequals = 1;
                            return -1;
                        }
                        if (nameA > nameB) {
                            notequals = 1;
                            return 1;
                        }
                        if (nameA == nameB) {
                            return 0;
                        }
                        return 0;
                    }
                } else {
                    if (column === "urgency") {
                        nameA = a.urgency !== 0 ? this.props.getLabels['WorkOrders.Urgency.' + a.urgency + '.Text'] : "";
                        nameB = b.urgency !== 0 ? this.props.getLabels['WorkOrders.Urgency.' + b.urgency + '.Text'] : "";
                    }
                    else if (column === "status") {
                        nameA = a.status !== 0 ? this.props.getLabels['WorkOrders.Status.' + a.status + '.Text'] : "";
                        nameB = b.status !== 0 ? this.props.getLabels['WorkOrders.Status.' + b.status + '.Text'] : "";
                    }
                    else if (column === "description") {
                        nameA = a[column].toLowerCase();
                        nameB = b[column].toLowerCase();
                    }
                    else {
                        nameA = a[column];
                        nameB = b[column];
                    }
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });

            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }

            if (selected[0].name == "tenantName") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "tenantName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "siteName") {
                SortData[2].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "siteName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "problemID") {
                SortData[3].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "problemID") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "description") {
                SortData[4].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "description") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "urgency") {
                SortData[5].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "urgency") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "assignedUserID") {
                SortData[6].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "assignedUserID") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "dueDate") {
                SortData[7].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "dueDate") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "status") {
                SortData[8].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "status") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "createdByDate") {
                SortData[9].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "createdByDate") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }

            if(this.state.FilterValue !== "6")
                this.props.getList.WorkOrderList = sortedData;
            else
                this.props.getList.ClosedWorkOrderList = sortedData;

            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('WorkOrderSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.FilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('WorkOrderFilterDetails', JSON.stringify(Data1));
        }
    };

    ViewWorkOrderDetails(Id, StatusId, createdByUserID) {
        if(this.props.ForEquipment !== undefined && this.props.ForEquipment !== null && this.props.ForEquipment)
        {
            this.props.HideButton();
        }
        this.setState({ redirect: true, WorkOrderId: Id, statusId: StatusId, CreatedByUserID: createdByUserID });
    }

    UpdateRedirection()
    {
        this.setState({ redirect: false});
    }

    getWeek() {
        var l_today = new Date();
        l_today.setHours(0, 0, 0, 0); //discard the time 
        var l_startDate = new Date();
        l_startDate.setHours(0, 0, 0, 0);

        var weekstart = l_today.getDate() - l_today.getDay() + 1;
        var weekend = weekstart + 6;       // end day is the first day + 6 
        var monday = new Date(l_startDate.setDate(weekstart));
        var sunday = new Date(l_today.setDate(weekend));
        return [monday, sunday];
    }

    OpenPrintPreview(){
        var imgURL = document.getElementById('test_trane_logo').src;
        var bottomimgURL = document.getElementById('TraneTech_Logo1').src;;
        var CurrentDateTime = new Date(); 
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth()+1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var selectedOption = this.refs.filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.filter_in_Select_input.options[selectedOption].id;
        var SelectedFilter = this.props.getLabels['WorkOrders.Filter.Options.' + lFilterId + '.Text'];
        var printContent = document.getElementById('divPrintWindow').outerHTML;
        var WindowHeight = ((window.screen.height)-200) + 'px';
        var WindowWidth = ((window.screen.width)-10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, scrollbars=yes');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;"><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');

        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class=\'row row_padding\'><div class='\col-md-12\'>");
        writeMe += ("<br/><label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float:left;margin-left:16px;'>Work Order Management</label><label class=\'workOrderlabel'\ style='float:right;margin-right:16px;'>"+CurrentDate+"</label><br/>");
        writeMe += ("<div style='margin:16px'><div style='position: relative;display: -webkit-flex;display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;-webkit-align-items: center;align-items: center;-webkit-justify-content: space-between;justify-content: space-between;padding: .5rem 1rem;background: transparent linear-gradient(270deg, #104095 0%, #2070CF 100%) 0% 0% no-repeat padding-box !important; min-height: 54px;-webkit-flex-flow: row nowrap;flex-flow: row nowrap;-webkit-justify-content: flex-start;justify-content: flex-start;'><img id='Trane_Logo' src="+imgURL+"></div></div>");
        writeMe += ("<label style='height: 15px;text-align: left;letter-spacing: 0px;color: #4A4A4A;opacity: 1;font-weight: bold;font-family: lato;font-size: 15px;padding-left: 15px;'\>Work Order</label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;padding-left: 16px; padding-bottom: 3px;'>Viewing: "+ SelectedFilter + "</label>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float: right; padding-right: 14px;'>"+PrintPaginationText+"</label>");
        writeMe += ("<div id='divPrintPreview'>" + printContent + "</div>");
        writeMe += ("<br/><br/><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class=\'print_footer'\ style='padding-left: 16px; padding-bottom: 3px;'>Tracer Ensemble<br/>© 2021 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='float:right'><img id='TraneTech_Logo' style='height: 30px;width: 142px;padding-right: 11px;' src="+bottomimgURL+" \></div><br/>");
        writeMe += ("<div style='borderTop:1px solid #FFFFFF; padding-bottom: 50px;'/><div style='margin-top:10px; margin-bottom:25px; margin-right:4px'><div style='float:right;'>");
        writeMe += ('<button type=\'button\' class=\'hide_in_print\' style=\'background: #F1f1f1 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #1756B2;width: 80px;height: 30px;float: right; margin-left: 6px; margin-top:3px; margin-right:10px; width:106px\' id=\'btnPrint\' onclick=\'javascript:window.close();\' >' + 'Close Window' + '</button>');
        writeMe += ('<button type=\'button\' class=\'hide_in_print\' style=\'background: #2070CF 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; margin-top:3px\' id=\'btnPrint\' onclick=\'javascript:window.print();\' >' + 'Print' + '</button>');
        writeMe += ("</div></div><br/>");
        writeMe += ('</body></html>');    
        printWindow.document.write(writeMe);
        printWindow.document.close(); 
        if (window.focus) {
            printWindow.focus();
        } 
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    DeleteWO = () => {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('WorkOrderRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
                break;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }

    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('WorkOrderRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    Data.push(checkboxes[i].id);
                }
            }
            if(this.props.ForEquipment){
                this.props.DeleteWorkOrder(Data, this.props.EquipmentSummaryId);
            }
            else{
                this.props.DeleteWorkOrder(Data,0);
            }
            document.getElementsByClassName("WO_header_Check_box")[0].checked = false;
        }
        this.Deletetoggle();
    }

    render(getList, getLabels, getWorkorderPreferences) {

        let lUserCanEdit, Filters_in_Select_input, IsWorkOrderEditRole, UserId = 1, lWolength = 0, lCurrentWolength = 0, Error_Message = null;
        let preferredfields = this.props.getWorkorderPreferences;
        let label = this.props.getLabels;
        let data = this.props.getList.WorkOrderList;
        lUserCanEdit = this.props.UserCanEdit;
        IsWorkOrderEditRole = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit === 2 ? true : false;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && (lUserCanEdit === 3 || lUserCanEdit === 2) ? true : false;
        let lUserCanDelete = this.props.UserCanEdit !== undefined && this.props.UserCanEdit !== null && this.props.UserCanEdit === 3 ? true : false;
        

        if (this.props.User_Details !== undefined && this.props.User_Details.user_info !== undefined) {
            UserId = this.props.User_Details.user_info.id;
        }

        if (label['WorkOrders.Filter.Options.Text'] !== undefined) {
            var Filetrs = label['WorkOrders.Filter.Options.Text'].split(',');
            Filters_in_Select_input = Filetrs.map(el => (
                <option id={el} value={el} >{label['WorkOrders.Filter.Options.' + el + '.Text']}</option>
            ));
        }

        //standard fields
        var tenant = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Tenant" && x.display === true) : '';
        var building = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Building" && x.display === true) : '';
        var problem = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : '';
        var description = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Description" && x.display === true) : '';
        var urgency = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Urgency" && x.display === true) : '';
        var assignedto = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : '';
        var status = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Status" && x.display === true) : '';
        var createdby = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "Created" && x.display === true) : '';
        var duedate = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.field === "DueDate" && x.display === true) : '';

        var tableColumns = preferredfields !== undefined && preferredfields !== "" ? preferredfields.filter(x => x.display === true).length : "10";
        let wolist = null;
        if (((this.props.getList.WorkOrderList !== null && this.props.getList.WorkOrderList !== undefined && this.props.getList.WorkOrderList.length > 0) || (this.props.getList.ClosedWorkOrderList !== null && this.props.getList.ClosedWorkOrderList !== undefined)) && !this.state.isloading  ) {
            let StructuredData = [];
            if(!this.props.ForEquipment){
                this.props.TriggerWorkOrderData(this.props.getList.WorkOrderList);
                this.props.TriggerWorkOrderClosedData(this.props.getList.ClosedWorkOrderList);
            }

            
            //Filter Functionality
            if (this.state.FilterValue !== "1") {
                if (this.state.FilterValue === "2") {
                    data = data.filter(x => x.assignedUserID === UserId && x.status !== 6);
                }
                else if (this.state.FilterValue === "3") {
                    data = data.filter(x => x.assignedUserID === 0 && x.status !== 6);
                }
                else if (this.state.FilterValue === "4") {
                    var l_date = new Date();
                    l_date.setHours(0, 0, 0, 0); //discard the time
                    data = data.filter(x => new Date(x.createdByDate).setHours(0, 0, 0, 0) === Number(l_date) && x.status !== 6);
                }
                else if (this.state.FilterValue === "5") {
                    var Dates = this.getWeek();
                    data = data.filter(x => new Date(x.createdByDate).setHours(0, 0, 0, 0) >= Number(Dates[0]) && new Date(x.createdByDate).setHours(0, 0, 0, 0) <= Number(Dates[1]) && x.status !== 6);
                }
                else if (this.state.FilterValue === "6") {
                   if(this.props.getList.ClosedWorkOrderList !== null && this.props.getList.ClosedWorkOrderList !== undefined){
                       data = this.props.ForEquipment ? this.props.getList.ClosedWorkOrderList.filter(x => x.workOrderDetail.equipmentID === parseInt(this.props.EquipmentSummaryId)) : this.props.getList.ClosedWorkOrderList;
                   }
                }
            }else{
                data = data.filter(x => x.status !== 6);
            }

            if (IsWorkOrderEditRole) {
                data = data.filter(x => x.assignedUserID === UserId);
            }
            if(this.state.IsMail){ //Handling EMail Link
                var lWorkOrderData = data.filter(x => x.workOrderID === this.state.WorkOrderId);
                if(lWorkOrderData[0] !== undefined && lWorkOrderData[0] !== null && lWorkOrderData[0].status !== undefined)
                    this.state.statusId = lWorkOrderData[0].status;
            }



            if(this.state.IsClosedStatus){
                let sortedData = data.sort((a, b) => {
                    let nameA, nameB;
                    nameA = a["workOrderID"];
                    nameB = b["workOrderID"];
                    return (nameA - nameB);
                });
                sortedData.reverse();
    
                data = sortedData;
                var array = this.state.sort.direction;
                    array.map(x => (x.name !== "workOrderID") ? x.onclick = false : x.onclick = true);
                    array.map(x => x.direction = "desc");
                this.state.sort = { column : 'workOrderID', direction: array };
            }

            if (this.state.IsDefaultSort && !this.state.IsClosedStatus) {
                var SortedDetails = sessionStorage.getItem('WorkOrderSortingDetails');
                if (SortedDetails !== undefined && SortedDetails !== null && SortedDetails !== "null") {
                    var PSortedDetails = JSON.parse(SortedDetails);
                    var column = PSortedDetails.column;
                    var direction = PSortedDetails.direction.filter(x => x.onclick === true)[0].direction;

                    if (column === 'workOrderID') {
                        let sortedData = data.sort((a, b) => {
                            let nameA, nameB;
                            nameA = a[column];
                            nameB = b[column];
                            return (nameA - nameB);
                        });
                        if (direction === 'desc') {
                            sortedData.reverse();
                        }
                        data = sortedData;
                        this.state.sort = { column, direction: PSortedDetails.direction };
                    }
                    else {
                        let sortedData = data.sort((a, b) => {
                            let nameA, nameB;
                            if (column === "siteName" || column === "problemID" || column === "tenantName") {
                                if (column === "problemID") {
                                    nameA = a.workOrderDetail.problemID === 8 ? a.workOrderDetail.otherProblem : (a.workOrderDetail.problemID !== 0 ? this.props.getLabels['WorkOrders.Problem.' + a.workOrderDetail.problemID + '.Text'] : "");
                                    nameB = b.workOrderDetail.problemID === 8 ? b.workOrderDetail.otherProblem : (b.workOrderDetail.problemID !== 0 ? this.props.getLabels['WorkOrders.Problem.' + b.workOrderDetail.problemID + '.Text'] : "");
                                }
                                else if (column === "tenantName") {
                                    nameA = a.workOrderDetail[column].toLowerCase();
                                    nameB = b.workOrderDetail[column].toLowerCase();
                                }
                                else if (column === "siteName") {
                                    let Buildings = this.props.getList.WorkorderBuildings;
                                    var buildingdts1 = [], buildingdts2 = [];
                                    if (Buildings !== null && Buildings !== undefined && Buildings.length > 0) {
                                        buildingdts1 = Buildings.filter(function (item) {
                                            return item.id === a.workOrderDetail.siteID
                                        });
                                        buildingdts2 = Buildings.filter(function (item) {
                                            return item.id === b.workOrderDetail.siteID
                                        });
                                    }
                                    nameA = (buildingdts1 !== [] && buildingdts1[0] !== undefined) ? buildingdts1[0].name : "";
                                    nameB = (buildingdts2 !== [] && buildingdts2[0] !== undefined) ? buildingdts2[0].name : "";
                                }
                            } else {
                                if (column === "urgency") {
                                    nameA = a.urgency !== 0 ? this.props.getLabels['WorkOrders.Urgency.' + a.urgency + '.Text'] : "";
                                    nameB = b.urgency !== 0 ? this.props.getLabels['WorkOrders.Urgency.' + b.urgency + '.Text'] : "";
                                }
                                else if (column === "status") {
                                    nameA = a.status !== 0 ? this.props.getLabels['WorkOrders.Status.' + a.status + '.Text'] : "";
                                    nameB = b.status !== 0 ? this.props.getLabels['WorkOrders.Status.' + b.status + '.Text'] : "";
                                }
                                else if (column === "description") {
                                    nameA = a[column].toLowerCase();
                                    nameB = b[column].toLowerCase();
                                }
                                else {
                                    nameA = a[column];
                                    nameB = b[column];
                                }
                            }

                            if (nameA < nameB) {
                                return -1;
                            }
                            if (nameA > nameB) {
                                return 1;
                            }
                            if (nameA == nameB) {
                                return 0;
                            }
                            return 0;
                        });

                        if (direction == 'desc') {
                            sortedData.reverse();
                        }
                        data = sortedData;
                        this.state.sort = { column, direction: PSortedDetails.direction };
                    }
                } else {
                    let sortedData = data.sort((a, b) => {
                        let nameA = a['createdByDate'];
                        let nameB = b['createdByDate'];
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        if (nameA == nameB) {
                            return 0;
                        }
                        return 0;
                    });
                    sortedData.reverse();
                }
            }

            data.forEach(el => {
                var lineitem = {
                    "workOrderID": el.workOrderID,
                    "serialNumber": el.serialNumber,
                    "tenantName": el.workOrderDetail.tenantName !== "" ? el.workOrderDetail.tenantName : <b>---</b>,
                    "buildingName": el.workOrderDetail.siteID !== 0 && el.workOrderDetail.siteName !== "" ? el.workOrderDetail.siteName : <b>---</b>,
                    "problem": (el.workOrderDetail.problemID !== 0) ? ((problem.length > 0 && problem[0] != undefined) ? problem[0].value.filter(x => x.key == el.workOrderDetail.problemID)[0].value : "Light not working") : <b>---</b>,
                    "description": (el.description !== "" ? el.description : <Label className="workorderlbl-noentry">No Description</Label>),
                    "urgency": (el.urgency !== 0) ? ((urgency.length > 0) ? urgency[0].value.filter(x => x.key == el.urgency)[0].value : "Low") : <b>---</b>,
                    "technicianName":(el.assignedName !== "" ? el.assignedName : <b>---</b>),
                    "status": (el.status > 0) ? (status.length > 0 ? status[0].value.filter(x => x.key == el.status)[0].key : 1) : 1,
                    "statusName": (el.status > 0) ? (status.length > 0 ? status[0].value.filter(x => x.key == el.status)[0] !== undefined ? status[0].value.filter(x => x.key == el.status)[0].value : "" : "Open - To be scheduled") : <b>---</b>,
                    "createdByDate": new Date(el.createdByDate).toDateString(),
                    "dueDate": el.dueDate === '1753-01-01T00:00:00' ? '---' : new Date(el.dueDate).toDateString(),
                    "isDueDatePassed" : el.isDueDatePassed,
                    "createdByUserID" : el.createdByUserID
                }
                StructuredData.push(lineitem);
            });
            
            let FilteredData = StructuredData.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            lWolength = FilteredData.length;
            //Reset header checkbox based on row checkbox 
            // if(document.querySelectorAll('input[type="checkbox"]').length && document.querySelectorAll('input.WorkOrderRows').length){
            //     let l_CurrentPageLength = (this.state.currentPage*50)+lCurrentWolength;
            //     if((document.querySelectorAll('input.WorkOrderRows:checked').length !== l_CurrentPageLength) || (document.querySelectorAll('input.WorkOrderRows:checked').length === 0))
            //         document.getElementsByClassName("WO_header_Check_box")[0].checked = false;
            //     else
            //         document.getElementsByClassName("WO_header_Check_box")[0].checked = true;
            // }
            pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
            wolist = FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize
            ).map(el => (
                <tr key={el.workOrderID}>
                    <td><input type="checkbox" id={el.workOrderID} className="WorkOrderRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("WorkOrderRows", "WO_header_Check_box"); }} /></td>
                    <td>
                        {
                            lUserCanEdit ? <p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => { this.ViewWorkOrderDetails(el.workOrderID, el.status, el.createdByUserID) }} >{el.serialNumber}</p> : <p className="link_cursor">{el.serialNumber}</p>
                        }
                    </td>
                    {(tenant.length > 0) ? <td>{el.tenantName}</td> : ""}
                    {(building.length > 0) ? <td>{el.buildingName}</td> : ""}
                    {(problem.length > 0) ? <td>{el.problem}</td> : ""}
                    {(description.length > 0) ? <td>{el.description}</td> : ""}
                    {(urgency.length > 0) ? <td>{el.urgency}</td> : ""}
                    {(assignedto.length > 0) ? <td>{el.technicianName}</td> : ""}
                    {(duedate.length > 0)  
                      ? ((el.isDueDatePassed === true && el.status !== 6 && el.dueDate !== "---") ?<td>{el.dueDate}<Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /> <Label style={{ 'color': 'red' }} >Past Due</Label> </td> 
                      : <td>{el.dueDate}</td>)
                      :""}
                    {(status.length > 0) ?  <td>{el.statusName} </td> : ""   }
                    {(createdby.length > 0) ? <td>{el.createdByDate}</td> : ""}
                </tr>
        )) : <tr><td colSpan={tableColumns}>{label['WorkOrders.Table.Default.Text']}</td></tr> ;            
            
            if(wolist.length !== undefined)
                lCurrentWolength = wolist.length;
        }else if(!this.state.isloading){
            wolist = <tr><td colSpan={tableColumns}>{label['WorkOrders.Table.Default.Text']}</td></tr>  
        }else{
            wolist = <tr><td colSpan={tableColumns} style={{textAlign: 'center'}}><LoadingIndicator/></td></tr> 
        } 

        let WOListTable = <div className="table_container table_border" id="divPrintWindow" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
        <Table striped responsive className="Custom_table fixed_layout" >
            <tbody className="cell_container">
                <tr>
                    <th width="2%"><input type="checkbox" className="WO_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("WorkOrderRows", "WO_header_Check_box"); }}/></th>
                    <th width="8%" className="wo_cursor" onClick={this.onSortNumber('workOrderID')}>
                        <span>{label !== undefined && label['WorkOrders.Columns.Record.Text'] !== undefined ? label['WorkOrders.Columns.Record.Text'] : "Record#"}</span>
                        <span className={(this.state.sort.direction[0].name == "workOrderID") ?
                            (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                        </span>
                    </th>
                    {
                        (tenant.length > 0) ?
                            <th width="9%" className="wo_cursor" onClick={this.onSort('tenantName')}>{tenant[0].fieldLabel}
                                <span className={(this.state.sort.direction[1] !== undefined && this.state.sort.direction[1].name == "tenantName") ?
                                    (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (building.length > 0) ?
                            <th width="9%" className="wo_cursor" onClick={this.onSort('siteName')}>{building[0].fieldLabel}
                                <span className={(this.state.sort.direction[2] !== undefined && this.state.sort.direction[2].name == "siteName") ?
                                    (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (problem.length > 0) ?
                            <th width="9%" className="wo_cursor" onClick={this.onSort('problemID')}>{problem[0].fieldLabel}
                                <span className={(this.state.sort.direction[3] !== undefined && this.state.sort.direction[3].name == "problemID") ?
                                    (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (description.length > 0) ?
                            <th width="15%" className="wo_cursor" onClick={this.onSort('description')}>{description[0].fieldLabel}
                                <span className={(this.state.sort.direction[4] !== undefined && this.state.sort.direction[4].name == "description") ?
                                    (this.state.sort.direction[4].onclick) ? (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (urgency.length > 0) ?
                            <th width="9%" className="wo_cursor" onClick={this.onSort('urgency')}>{urgency[0].fieldLabel}
                                <span className={(this.state.sort.direction[5] !== undefined && this.state.sort.direction[5].name == "urgency") ?
                                    (this.state.sort.direction[5].onclick) ? (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (assignedto.length > 0) ?
                            <th width="9%" className="wo_cursor" onClick={this.onSort('assignedUserID')} >{assignedto[0].fieldLabel}
                                <span className={(this.state.sort.direction[6] !== undefined && this.state.sort.direction[6].name == "assignedUserID") ?
                                    (this.state.sort.direction[6].onclick) ? (this.state.sort.direction[6].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[6].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (duedate.length > 0) ?
                            <th width="10%" className="wo_cursor" onClick={this.onSort('dueDate')} >{duedate[0].fieldLabel}
                                <span className={(this.state.sort.direction[7] !== undefined && this.state.sort.direction[7].name == "dueDate") ?
                                    (this.state.sort.direction[7].onclick) ? (this.state.sort.direction[7].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[7].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (status.length > 0) ?
                            <th width="10%" className="wo_cursor" onClick={this.onSort('status')} >{status[0].fieldLabel}
                                <span className={(this.state.sort.direction[8] !== undefined && this.state.sort.direction[8].name == "status") ?
                                    (this.state.sort.direction[8].onclick) ? (this.state.sort.direction[8].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[8].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                    {
                        (createdby.length > 0) ?
                            <th width="10%" className="wo_cursor" onClick={this.onSort('createdByDate')}>{createdby[0].fieldLabel}
                                <span className={(this.state.sort.direction[9] !== undefined && this.state.sort.direction[9].name == "createdByDate") ?
                                    (this.state.sort.direction[9].onclick) ? (this.state.sort.direction[9].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                        : (this.state.sort.direction[9].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                                </span>
                            </th> : ""
                    }
                </tr>
                {wolist}
            </tbody>
        </Table>
        </div>
        PrintPaginationText = (lWolength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentWolength) + " of " + lWolength + " records";
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error_wo}</p> : Error_Message = "";
        return (
            <div className={this.props.Premise ? (this.props.ForEquipment ? "main_container workOrderContainer": "main_container") : this.props.ForEquipment ? "cloud_main_container workOrderContainer": "cloud_main_container"} >
                <div className={this.props.ForEquipment ? "" : "border_container"}>
                {
                    this.props.ForEquipment ? "" : String.fromCharCode(160)
                }
                {
                    this.state.redirect ? <WorkOrderDetails WorkOrderId={this.state.WorkOrderId} ForEquipment={this.props.ForEquipment} StatusId={this.state.statusId} Premise={this.props.Premise} UpdateRedirection={this.UpdateRedirection} ShowCreateButton={this.props.ShowCreateButton} CreatedByUserID={this.state.CreatedByUserID} /> : 
                <div className={this.props.ForEquipment ? "main_container workOrderContainer": "main_container"} >
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px','margin-bottom':'24px'}}>
                    <div className="col-md-6">
                        {Error_Message}
                    </div>
                    <div className="col-md-6" style={{'display':this.props.ForEquipment ?'none':'block'}}>
                        <FaPrint className="icons-Menu-print" onClick={this.OpenPrintPreview} />
                    </div>
                </div>
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                <div className="col-md-6">
                    <label className={this.props.ForEquipment ? "workOrderlabel" : ""} style={{ fontFamily: 'lato', fontSize: '13px', fontWeight:'bold', color:'black'}}>{label !== undefined ? label['WorkOrders.Filter.Viewing.Text'] : "Viewing:"}</label>
                    <select ref='filter_in_Select_input' style={{ "margin-left": "10px", "margin-top": "10px" }} className="pmminimal pm-dropdown" value={this.state.FilterValue} onChange={this.OnFilterChange}>
                        {Filters_in_Select_input}
                    </select>
                </div>
                <div className="col-md-6" style={{paddingTop:'11px'}}>
                    <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', marginLeft: '26px', float: 'right', 'margin-top': '4px' }}>{(lWolength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentWolength) + " of " + lWolength + " records"}</label>
                    { lUserCanDelete ? <Button className="child_tab_button" onClick={() => this.DeleteWO()}>{label['WorkOrders.DeleteTenant.Text'] !== undefined ? label['WorkOrders.DeleteTenant.Text'] : "DELETE"}</Button> : "" }
                    <span className="pm_outersearchbox" style={{ float: 'right' }}>
                        <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='wo_search_value' />
                    </span>
                    <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'margin-top': '4px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                </div>
                </div>
                <br/>
                {WOListTable}
                <div className="row row_padding pm_pagination" style={{'margin-right':'15px'}}>
                    <div className="col-md-7">
                        <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me pagination_margin'}
                        breakLinkClassName={'pagination_link_color'}
                        pageCount={pagesCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination pagination_container_margin'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        disabledClassName={'pagination_disable_link'}
                        pageClassName={'pagination_margin'}
                        pageLinkClassName={'pagination_link_color'}
                        previousClassName={'pagination_margin'}
                        previousLinkClassName={'pagination_link_color'}
                        nextClassName={'pagination_margin'}
                        nextLinkClassName={'pagination_link_color'}
                        forcePage={this.state.currentPage -1}
                        />
                    </div>
                    <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={"ModalContainer short_modal"} >
                        <DeleteConfirmation parentToChildData={["Delete Work Order", "You are about to delete a work order from the system. Do you want to continue?", "Close Window", "Delete Work Order"]} Delete={this.Delete} />
                    </Modal>
                </div>
                </div>
                }
                </div>
                <div>
                    <img id="test_trane_logo" alt="Trane" src={TraneLogo} style={{"display":"none"}}/>
                    <img id='TraneTech_Logo1' alt="Trane1" src={TraneTechLogo} style={{"display":"none"}} />
                </div>
            </div>
        );
    }
};
const mapStateToProps = state => {
    return {
        getList: state.WorkorderRootReducer,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        User_Details: state.userDetailsRootReducer
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderList: () => dispatch(GetWorkorderList()),
        GetClosedWorkorderList: () => dispatch(GetClosedWorkorderList()),
        getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        getAllResources: () => dispatch(getAllResources()),
        GetEquipmentWorkorderList: (id) => dispatch(GetEquipmentWorkorderList(id)),
        DeleteWorkOrder: (WorkOrderID, equipmentID) => dispatch(DeleteWorkOrder(WorkOrderID,equipmentID)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Workorderlist);